import script from "./TasksMixin.vue?vue&type=script&lang=js"
export * from "./TasksMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__